module.exports = __webpack_public_path__ + "static/media/files-medical.a337a5dd.svg";